import { Injectable } from '@angular/core';
import { Observable, defer, map, shareReplay } from 'rxjs';
import { AvailableGuardrailType, listAvailableGuardrailTypes$ } from '@vendasta/protos/ai_assistants/v1alpha1';

@Injectable({ providedIn: 'root' })
export class GuardrailTypesService {
  /** Multicasts one fetch; an error resets the replay so the next subscriber retries. */
  readonly types$: Observable<AvailableGuardrailType[]> = defer(() => listAvailableGuardrailTypes$({})).pipe(
    map((response) => response.guardrailTypes),
    shareReplay({ refCount: true, bufferSize: 1 }),
  );
}
